
export const buildPassengerRequest = ({ clientCode, key, referenceNo, contactDetails, travellers, ssrInfo, pricing, userName, }) => {
  // const allPassengers = [
  //   ...(travellers?.adults || []),
  //   ...(travellers?.children || []),
  //   ...(travellers?.infants || []),
  // ];
  const allPassengers = [
    ...(travellers?.adults?.map((pax) => ({
      title: pax.title,
      firstName: pax.firstName,
      lastName: pax.lastName,
      dateOfBirth: pax.dob,
      paxType: "ADT",
      passportNumber: pax.passportNo,
      ffNo: pax.frequentFlyerNo || "",
      nationality: pax.nationality,
      issuingCountry: pax.issuingCountry,
      passportIssueDate: pax.issueDate,
      expiryDate: pax.expiryDate,
      isSaveTravellerInfo: pax.saveInfo || false,
    })) || []),

    ...(travellers?.children?.map((pax) => ({
      title: pax.title,
      firstName: pax.firstName,
      lastName: pax.lastName,
      dateOfBirth: pax.dob,
      paxType: "CHD",
      passportNumber: pax.passportNo,
      ffNo: pax.frequentFlyerNo || "",
      nationality: pax.nationality,
      issuingCountry: pax.issuingCountry,
      passportIssueDate: pax.issueDate,
      expiryDate: pax.expiryDate,
      isSaveTravellerInfo: pax.saveInfo || false,
    })) || []),

    ...(travellers?.infants?.map((pax) => ({
      title: pax.title,
      firstName: pax.firstName,
      lastName: pax.lastName,
      dateOfBirth: pax.dob,
      paxType: "INF",
      passportNumber: pax.passportNo,
      ffNo: pax.frequentFlyerNo || "",
      nationality: pax.nationality,
      issuingCountry: pax.issuingCountry,
      passportIssueDate: pax.issueDate,
      expiryDate: pax.expiryDate,
      isSaveTravellerInfo: pax.saveInfo || false,
    })) || []),
  ];

  return {
    clientCode,
    key,
    referenceNo,
    customerInfo: {
      userID: contactDetails.userID,
      email: contactDetails.emailId,
      mobileCountryCode: contactDetails.countryCode,
      mobile: contactDetails.mobile,
      address: "",
      userID: userName,
      passengerDetails: allPassengers,
    },
    ssrInfo: ssrInfo || [],
    totalAmount: pricing?.totalAmount || 0,
    ssrAmount: pricing?.ssrAmount || 0,
    discount: pricing?.discount || 0,
    grandTotalFare: pricing?.grandTotalFare || 0,
    isGSTProvided: false,
    gstDetails: {},
    isSendBookingDetailOnWhatsApp: false,
  };
};
